/**
 * @file Defines the {@link BUTTON_SIZE} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Button sizes for each device.
  * @type {object}
  * @constant
  * @default
  * @property {object} desktop   - Desktop config.
  * @property {object} mobile    - Mobile config.
  * @property {object} landscape - Landscape config.
  * @property {object} portrait  - Portrait config.
  * @property {string} size      - Button size.
  */
 export const BUTTON_SIZE = {

    desktop: {

        autospin: {
            size: 'sm'
        },

        bet: {
            size: 'sm'
        },

        menu: {
            size: 'sm'
        },

        paytable: {
            size: 'sm'
        },

        sound: {
            size: 'sm'
        },

        spin: {
            size: 'lg'
        }

    },

    mobile: {

        landscape: {

            autospin: {
                size: 'md'
            },
    
            bet: {
                size: 'md'
            },

            menu: {
                size: 'sm'
            },
    
            paytable: {
                size: 'sm'
            },
    
            sound: {
                size: 'sm'
            },
    
            spin: {
                size: 'lg'
            }

        },

        portrait: {

            autospin: {
                size: 'sm'
            },
    
            bet: {
                size: 'sm'
            },

            menu: {
                size: 'sm'
            },
    
            paytable: {
                size: 'sm'
            },
    
            sound: {
                size: 'sm'
            },
    
            spin: {
                size: 'lg'
            }

        }

    }

 } 